import { render, staticRenderFns } from "./AnnouncementManagement.vue?vue&type=template&id=71602de7&scoped=true"
import script from "./AnnouncementManagement.vue?vue&type=script&lang=js"
export * from "./AnnouncementManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71602de7",
  null
  
)

export default component.exports